import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { useModal } from '../providers/ModalProvider';
import { launchDigitex } from '../utils/digitexSso';

const DigitexLink = ({ className = '', label = 'Digitex' }) => {
  const navigate = useNavigate();
  const modal = useModal();
  const [isLaunching, setIsLaunching] = useState(false);
  const userDataDetail = useSelector((state) => state?.auth?.userDataDetail);

  const handleLaunch = async (event) => {
    event.preventDefault();

    if (!userDataDetail?.id) {
      navigate('/login?returnTo=digitex');
      return;
    }

    try {
      setIsLaunching(true);
      await launchDigitex(userDataDetail?.token || localStorage.getItem('token'));
    } catch (error) {
      modal.showAttention({
        subtitle: error?.response?.data?.message || 'Digitex non è disponibile per questo account.',
      });
      setIsLaunching(false);
    }
  };

  if (!userDataDetail?.id) {
    return <Link className={className} to="/login?returnTo=digitex">{label}</Link>;
  }

  return <a className={className} href="#digitex" onClick={handleLaunch}>{isLaunching ? 'Apertura Digitex…' : label}</a>;
};

DigitexLink.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

export default DigitexLink;
